import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const header = css`
  display: flex;
  align-items: center;
`

export const flag = css`
  width: ${4 * unit}px;
`

export const logoWrapper = css`
  text-align: right;
`

export const logo = css`
  width: ${16 * unit}px;
`

export const athleteList = css`
  li {
    display: inline-block;

    margin: ${unit}px;
  }
`
